module.exports = __webpack_public_path__ + "static/media/apex-fintech-solutions.7d4dbfcf.png";